// formemoveinzu widgete

$(document).ready(function() {
	
	/* globally defined variables ===================================================================
	===============================================================================================*/
	//var myFormErr			= $("#contentWrapper .contentSection .formError"); 
	//var myTextAreas  		= $("#contentWrapper .contentSection form").find("textarea, div.textInput");
	var active 		 		= false;
	//var lastValue 	 		= $(".simpleSelectToggler");
	//var answersContainer 	= $(".simpleSlcContainerSample");
	
	/* error-handling on text areas ballon tips =====================================================
	===============================================================================================*/
	/*
	myFormErr.focusin  (function() { 
		$(this).next().animate({"opacity" : 0.5}); });
	myFormErr.focusout (function() { 
		$(this).next().animate({"opacity" : 1}); });
	*/
	
	/* focusin/out handling on text areas size ======================================================
	===============================================================================================*/
	/* important focus-out behavior */
	/*
	myTextAreas.focusout(function() { myTextAreas.stop(true, true).animate({"height" : 50}, 250); });
	
	myTextAreas.focusin(function() { 
		if (active == true) {
				myTextAreas.stop().animate({"height" : 50}, 250);
				$(this).animate({"height" : 150}, 600);	
		} else {
			$(this).animate({"height" : 150}, 600);
			active = true;
		};
		
	});
	*/
 
  /* add answers ======================================================================================  
  ===================================================================================================*/  
  $(".triggerMA").on("click", function() {
    
    $addButton = $(this);
    
    var videoNumber = $addButton.attr('rel');
    var taskType = $addButton.attr('taskType');
    var highestAnswerNumber = $addButton.parent('.answersSection').find('input:last').attr('name').split('[');
    highestAnswerNumber = highestAnswerNumber[highestAnswerNumber.length-2];
    highestAnswerNumber = highestAnswerNumber.slice(0,-1);  
    var latestAnswer  = parseInt(highestAnswerNumber) + 1;
   
    var newInputBox = '<fieldset><div class="simpleSlcContainer">';
    newInputBox += '<input class="textInput" size="100" type="text" name="tx_bewegunglesen_bewegunglesentasklist['+taskType+'][videos]['+videoNumber+'][answers]['+latestAnswer+'][answer]"></input>';
    newInputBox += '<input type="hidden" name="tx_bewegunglesen_bewegunglesentasklist['+taskType+'][videos]['+videoNumber+'][answers]['+latestAnswer+'][answerSolution]" value=""></input>';
    newInputBox += '<input class="checkbox" type="checkbox" name="tx_bewegunglesen_bewegunglesentasklist['+taskType+'][videos]['+videoNumber+'][answers]['+latestAnswer+'][answerSolution]" value="1"></input>';
    newInputBox += '<div class="simpleSelectToggler"><a class="uiButton uiButtonSmall"><span></span></a></div></div></fieldset>';
 
     /* reform checkboxes for answers with uniform on demand */
    $(newInputBox).insertBefore($addButton).find('input:checkbox').uniform();
  });
  
  /* remove answers from task edit/new view ===========================================================  
  ===================================================================================================*/  
  $(".simpleSelectToggler").live("click", function() {
    $delButton = $(this);
    $delButton.closest('fieldset').remove();
  });


  /* reform checkboxes for answers with uniform */
  $('.formContent .answersSection input:checkbox').uniform();
	
	
});

